module.exports = __webpack_public_path__ + "img/profile2.779ff4d8.png";